import React from "react";
import useAppNavigation from "../../hooks/useAppNavigation";

import Nombre from "../MCCRETARITAG/Nombre";
import DangerousBreed from "../MCCRETARITAG/DangerousBreed";
import Microchip from "../MCCRETARITAG/Microchip";
import FecNacimiento from "../MCCRETARITAG/FecNacimiento";
import Raza from "../MCCRETARITAG/Raza";
import FecEfecto from "../MCCRETARITAG/FecEfecto";
import NombrePersona from "../MCCPERSTAG/NombrePersona";
import Apellido1 from "../MCCPERSTAG/Apellido1";
import Apellido2 from "../MCCPERSTAG/Apellido2";
import Nif from "../MCCPERSTAG/Nif";
import TipoDocumento from "../MCCPERSTAG/TipoDocumento";
import TelefonoParticular from "../MCCPERSTAG/TelefonoParticular";
import Email from "../MCCPERSTAG/Email";
import FechaNacimiento from "../MCCPERSTAG/FechaNacimiento";
import CodPostal from "../MCCPERSTAG/CodPostal";
import NombreVia from "../MCCPERSTAG/NombreVia";
import NumVia from "../MCCPERSTAG/NumVia";
import Provincia from "../WOO/Provincia";
import Localidad from "../MCCPERSTAG/Localidad";
import Bloque from "../MCCPERSTAG/Bloque";
import Portal from "../MCCPERSTAG/Portal";
import Escalera from "../MCCPERSTAG/Escalera";
import Puerta from "../MCCPERSTAG/Puerta";
import Piso from "../MCCPERSTAG/Piso";

import WooProducts from "./WooProducts";
import { Information } from "../../assets/icons";
import TipoVia from "../MCCPERSTAG/TipoVia";

export default function FormStep({ content, wooProducts }) {
  const { currentStep } = useAppNavigation();

  const handleHelp = () => {
    const elem = document.getElementById("help-step-2");
    if (elem.classList.contains("d-none")) elem.classList.remove("d-none");
    else elem.classList.add("d-none");
  };

  return (
    <div>
      {currentStep && content && (
        <>
          <h1>
            {content["step_" + (currentStep.id + 1)]?.title}
            {currentStep?.id == 2 && (
              <span onClick={handleHelp}>
                <Information />
              </span>
            )}
          </h1>
        </>
      )}

      {currentStep?.id == 0 && (
        <>
          <Nombre />
          <DangerousBreed wooProducts={wooProducts} />
        </>
      )}
      {currentStep?.id == 1 && (
        <>
          <Microchip />
          <FecNacimiento title="Fecha de nacimiento" />
          <Raza />
          <FecEfecto label="¿Cuándo quieres que comience tu seguro?" />
        </>
      )}
      {currentStep?.id == 2 && (
        <>
          <div id="help-step-2" className="info-panel d-none">
            <span onClick={handleHelp}>
              <Information />
            </span>
            El <strong>tomador y asegurado deben ser la misma persona</strong>.
            El seguro
            <strong>
              cubre tanto a los propietarios como a los poseedores del perro
            </strong>
            , incluyendo a quienes lo estén paseando en el momento de causar
            daños a terceros.
          </div>

          <NombrePersona />
          <div className="row">
            <div className="col col-6">
              <Apellido1 />
            </div>
            <div className="col col-6">
              <Apellido2 />
            </div>
            <div className="col col-6">
              <TipoDocumento />
            </div>
            <div className="col col-6">
              <Nif />
            </div>
            <div className="col col-12 col-md-6">
              <TelefonoParticular />
            </div>
            <div className="col col-12 col-md-6">
              <Email />
            </div>
            <div className="col col-12 col-md-6">
              <FechaNacimiento />
            </div>
          </div>

          <CodPostal />
          <div className="row">
            <div className="col col-md-4">
              <TipoVia />
            </div>
            <div className="col col-md-6">
              <NombreVia />
            </div>
            <div className="col col-md-2">
              <NumVia />
            </div>
            <div className="col col-md-2">
              <Bloque />
            </div>
            <div className="col col-md-2">
              <Portal />
            </div>
            <div className="col col-md-2">
              <Escalera />
            </div>
            <div className="col col-md-2">
              <Piso />
            </div>
            <div className="col col-md-2">
              <Puerta />
            </div>
          </div>

          <Provincia />
          <Localidad />
          {/* <Poblacion /> */}
          {/* <Consentimiento /> */}
        </>
      )}
      {currentStep?.id == 3 && (
        <>
          <WooProducts wooProducts={wooProducts} />
          {/* <ConsentimientoContrato /> */}
        </>
      )}
    </div>
  );
}
